import React from "react";
import { getNestedError } from "../../utils/constants";
import styles from "./Input.module.css";

const Input = ({
  label,
  name,
  register,
  errors,
  validation = {},
  placeholder = "Please enter",
  type = "text",
  mandate = false,
  disabled = false,
  value,
  year = false,
  duration = false, // 👈 new prop
}) => {
  const error = getNestedError(errors, name);

  return (
    <div className={styles.wrapper}>
      <fieldset
        className={`${styles.fieldset}
          ${disabled ? styles.disabled : ""}
          ${error ? styles.error : ""}`}
      >
        <legend className={styles.legend}>
          {label} {mandate && <span className={styles.mandate}>*</span>}
        </legend>

        <input
          type={type}
          placeholder={placeholder}
          className={styles.input}
          disabled={disabled}
          defaultValue={value}
          inputMode={year ? "numeric" : "text"}
          maxLength={year ? 4 : undefined}
          {...register(name, {
            ...validation,

            ...(year && {
              maxLength: {
                value: 4,
                message: "Year must be 4 digits",
              },
              pattern: {
                value: /^[0-9]{4}$/,
                message: "Enter a valid year",
              },
            }),

            ...(duration && {
              pattern: {
                value: /^[A-Za-z0-9,\-\/ ]+$/,
                message:
                  "Only letters, numbers, space, '-' ',' and '/' are allowed",
              },
            }),
          })}
        />
      </fieldset>

      {error && <p className={styles.errorText}>{error.message}</p>}
    </div>
  );
};

export default Input;
